import { TVisibleForm, TTypeOfModalWindow } from './createModifierGroupsContext';
import {
	IItemForGetShortInfo,
	IServerError,
	ICreateModifierGroupValidationError,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	ICreateModifierGroups,
	IDishesByRestaurantIdsAndSubcategoryIdsItem,
} from 'types';

export enum CreateModifierGroupsActionTypes {
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_IDS_CATEGORIES = 'SET_IDS_CATEGORIES',
	SET_FETCHED_SUBCATEGORIES = 'SET_FETCHED_SUBCATEGORIES',
	SET_IDS_SUBCATEGORIES = 'SET_IDS_SUBCATEGORIES',
	SET_FETCHED_DISHES = 'SET_FETCHED_DISHES',
	SET_IDS_DISHES = 'SET_IDS_DISHES',
	CHANGE_NAME_OF_MODIFIER_GROUP = 'CHANGE_NAME_OF_MODIFIER_GROUP',
	SET_FETCHED_TRANSLATIONS = 'SET_FETCHED_TRANSLATIONS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeVisibleForm {
	type: CreateModifierGroupsActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TVisibleForm;
	};
}

interface ISetFetchedCustomers {
	type: CreateModifierGroupsActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		customers: IItemForGetShortInfo[];
	};
}

interface ISetIDCustomer {
	type: CreateModifierGroupsActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: Nullable<string>;
	};
}

interface ISetFetchedRestaurants {
	type: CreateModifierGroupsActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		restaurants: IItemForGetShortInfo[];
	};
}

interface ISetIDsRestaurant {
	type: CreateModifierGroupsActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: string[];
	};
}

interface ISetFetchedCategories {
	type: CreateModifierGroupsActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		fetchedCategories: IItemForGetShortInfo[];
	};
}

interface ISetIDsCategories {
	type: CreateModifierGroupsActionTypes.SET_IDS_CATEGORIES;
	payload: {
		IDsSelectedCategories: string[];
	};
}

interface ISetFetchedSubcategories {
	type: CreateModifierGroupsActionTypes.SET_FETCHED_SUBCATEGORIES;
	payload: {
		fetchedSubcategories: IItemForGetShortInfo[];
	};
}

interface ISetIDsSubcategories {
	type: CreateModifierGroupsActionTypes.SET_IDS_SUBCATEGORIES;
	payload: {
		IDsSelectedSubcategories: string[];
	};
}

interface ISetFetchedDishes {
	type: CreateModifierGroupsActionTypes.SET_FETCHED_DISHES;
	payload: {
		dishes: IDishesByRestaurantIdsAndSubcategoryIdsItem[];
	};
}

interface ISetIDsDishes {
	type: CreateModifierGroupsActionTypes.SET_IDS_DISHES;
	payload: {
		IDsSelectedDishes: string[];
	};
}

interface IChangeNameOfModifierGroup {
	type: CreateModifierGroupsActionTypes.CHANGE_NAME_OF_MODIFIER_GROUP;
	payload: {
		nameOfModifierGroup: string;
	};
}

interface ISetFetchedTranslation {
	type: CreateModifierGroupsActionTypes.SET_FETCHED_TRANSLATIONS;
	payload: {
		translations: IMenuTranslation[];
		defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	};
}

interface ISetTranslationTab {
	type: CreateModifierGroupsActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: TLanguageIDs | null;
	};
}

interface IChangeTranslation {
	type: CreateModifierGroupsActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IMenuTranslation[];
	};
}

interface ISetDataForSubmit {
	type: CreateModifierGroupsActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateModifierGroups | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateModifierGroupsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IShowErrorModalWithInfo {
	type: CreateModifierGroupsActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IServerError<ICreateModifierGroupValidationError> | null;
	};
}

interface IResetSelectedControls {
	type: CreateModifierGroupsActionTypes.RESET_FIELDS;
}

export type TCreateModifierGroupsAction =
	| IChangeVisibleForm
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| ISetFetchedCategories
	| ISetIDsCategories
	| ISetFetchedSubcategories
	| ISetIDsSubcategories
	| ISetFetchedDishes
	| ISetIDsDishes
	| IChangeNameOfModifierGroup
	| ISetFetchedTranslation
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| IResetSelectedControls;
